import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Input from "../../../../common/Input";
import Button from "react-bootstrap/Button";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {Badge, Spinner} from "react-bootstrap";
import BetterCheckBox from "../../../../common/BetterCheckBox";
import {asArray} from "../constants";
import {isEmpty} from "../../../../../_helpers/commonFunctions";

const ExamsModal = ({show, setShow, examType, handleAdd, handleAddMany, backButtonMessage, diagnoses}) => {
    const activeVisit = useSelector((state) => state.PRESCRIPTION.activeVisit);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [exams, setExams] = useState([]);
    const [filter, setFilter] = useState("");
    const [loading, setLoading] = useState(false);

    const [showOnlyFavorite, setShowOnlyFavorite] = useState(true);
    const [showRecommended, setShowRecommended] = useState(true);

    useEffect(() => {
        if (show) {
            fetchExams();
        } else {
            resetModal();
        }
    }, [show])

    useEffect(() => {
        if (show && examType) {
            fetchExams();
        }
    }, [examType])

    const resetModal = () => {
        setShowOnlyFavorite(false);
        setShowRecommended(false);
    }

    const fetchExams = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/examinations`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                filter: filter,
                examinationGroupId: examType || "",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                let resData = res.data.data;
                let patientParentSocialInsurances = [];
                if (activeVisit?.activeInsurance?.socialInsurance) {
                    let arr = asArray(activeVisit?.activeInsurance?.socialInsurance);
                    patientParentSocialInsurances = arr.map((o) => o.parentSocialInsuranceId).filter(Boolean);
                }
                resData = resData.filter((el) => {
                    if (el?.examinationSocialInsurances?.examinationSocialInsurance) {
                        const arr = asArray(el?.examinationSocialInsurances?.examinationSocialInsurance);
                        if (arr.some((el) => patientParentSocialInsurances.includes(el.socialInsuranceId) && el.isActive === "true")) {
                            return el;
                        }
                    }
                    return null;
                }).filter(Boolean);

                for (let d of resData) {
                    if (d?.icd10hooks?.some((el) => diagnoses.some((el2) => el2.code === el.code))) {
                        d.erp_recommended = true;
                    }
                    d.erp_amount = "";
                }
                resData.sort((a, b) => {
                    const getPriority = (item) => item.erp_favorite ? 0 : item.erp_recommended ? 1 : 2;
                    const priorityDiff = getPriority(a) - getPriority(b);
                    if (priorityDiff !== 0) return priorityDiff;
                    return String(a.description).localeCompare(String(b.description), "el");
                })
                setExams(resData);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleAddFavorites = () => {
        handleAddMany(exams.filter((el) => {
            if (showOnlyFavorite) {
                if (el.erp_favorite) return el;
            } else {
                return el;
            }
            return null;
        }).filter(Boolean));
        setShow(false);
    }

    const handleAddRecommended = () => {
        handleAddMany(exams.filter((el) => {
            if (showRecommended) {
                if (el.erp_recommended) return el;
            } else {
                return el;
            }
            return null;
        }).filter(Boolean));
        setShow(false);
    }

    return (
        <React.Fragment>
            {/* Exams Modal */}
            <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Εισαγωγή εξετάσεων {!isEmpty(activeVisit.socialSecurityShortName) && <span>(Ασφαλιστικού Φορέα: {activeVisit.socialSecurityShortName})</span>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{display: "flex", gap: "10px"}} onKeyDown={(e) => {
                        if (e.key === "Enter") fetchExams();
                    }}>
                        <div style={{ flex: "6" }}>
                            <Input
                                name={"filter"}
                                unlabbled={true}
                                value={filter}
                                placeholder={"Αναζήτηση εξετάσεων"}
                                onChange={(e) => setFilter(e.target.value)}
                            />
                        </div>
                        <Button style={{ flex: "4" }} size={"sm"} disabled={loading} onClick={() => fetchExams()}>
                            Αναζήτηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </div>
                    {exams.length > 0 && (
                        <div style={{maxHeight: "60vh", overflowY: "auto"}} className={"mt-1"}>
                            {exams.some((el) => el.erp_favorite) && (
                                <div style={{display: "flex"}}>
                                    <div className={"mb-1"}>
                                        Με κίτρινο χρώμα αναγράφονται οι αγαπημένες εξετάσεις
                                    </div>
                                    <div>
                                        <BetterCheckBox
                                            className={"m-0 ml-2"}
                                            name={"showFavorites"}
                                            text={"Προβολή μόνο αγαπημένων"}
                                            checked={showOnlyFavorite}
                                            onChange={(e) => {
                                                setShowOnlyFavorite(e.target.checked);
                                                setShowRecommended(false);
                                            }}
                                        />
                                    </div>
                                    {showOnlyFavorite && (
                                        <div>
                                            <Button className={"ml-2 mb-1"} size={"sm"} onClick={() => handleAddFavorites()}>Προσθήκη όλων των αγαπημένων εξετάσεων</Button>
                                        </div>
                                    )}
                                </div>
                            )}
                            {exams.some((el) => el.erp_recommended) && (
                                <div style={{display: "flex"}} className={"pt-1 border-top"}>
                                    <div className={"mb-1"}>
                                        Με πράσινο χρώμα αναγράφονται οι προτεινόμενες εξετάσεις με βάση τα επιλεγμένα ICD-10
                                    </div>
                                    <div>
                                        <BetterCheckBox
                                            className={"m-0 ml-2"}
                                            name={"showRecommended"}
                                            text={"Προβολή μόνο των προτεινόμενων"}
                                            checked={showRecommended}
                                            onChange={(e) => {
                                                setShowRecommended(e.target.checked);
                                                setShowOnlyFavorite(false);
                                            }}
                                        />
                                    </div>
                                    {showRecommended && (
                                        <div>
                                            <Button className={"ml-2 mb-1"} size={"sm"} onClick={() => handleAddRecommended()}>Προσθήκη όλων των προτεινόμενων εξετάσεων</Button>
                                        </div>
                                    )}
                                </div>
                            )}
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "65%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "5%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Εξέταση</th>
                                    <th>Τιμή</th>
                                    <th>Ποσότητα</th>
                                    <th>&nbsp;</th>
                                </tr>
                                </thead>
                                <tbody>
                                {exams.filter((el) => {
                                    if (showOnlyFavorite) {
                                        if (el.erp_favorite) return el;
                                    } else {
                                        if (showRecommended) {
                                            if (el.erp_recommended) return el;
                                        } else {
                                            return el;
                                        }
                                    }
                                    return null;
                                }).filter(Boolean).map((item, idx) => (
                                    <tr key={`examsModal-${idx}`} style={{backgroundColor: item?.erp_favorite ? "#fcf99f" : item?.erp_recommended ? "#d6fcb8" : ""}}>
                                        <td>{item.description}</td>
                                        <td>{item.price}</td>
                                        <td><input type={"number"} onChange={(e) => {
                                            const cloneExams = structuredClone(exams);
                                            cloneExams[idx].erp_amount = +e.target.value;
                                            setExams(cloneExams);
                                        }} style={{display: "flex", width: "100%"}} /></td>
                                        <td>
                                            <Badge bg={"success"} title={"Προσθήκη"} style={{padding: "6px", paddingTop: "2px", paddingBottom: "2px", cursor: "pointer", fontSize: "20px"}}
                                                   onClick={() => {
                                                       let val = 1;
                                                       if (+item.erp_amount) val = +item.erp_amount;
                                                       handleAdd(item, val)
                                                   }}>+</Badge>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" size={"sm"} onClick={() => setShow(false)}>
                        {backButtonMessage}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default ExamsModal
